import React from "react";
import { Navigate } from "react-router-dom";
import { clearAuthUser, getAuthUser, isTokenExpired } from "../../helpers/auth";

const RoleBasedAuth = ({ children }: { children: React.ReactNode }) => {
  const authUser = getAuthUser();

  if (!authUser?.token) {
    return <Navigate to="/login" replace />;
  }
  if (isTokenExpired()) {
    clearAuthUser();
    return <Navigate to="/login" replace />;
  }
  const roles = Array.isArray(authUser?.roles) ? authUser.roles : [];
  if (roles.length <= 0) {
    return <Navigate to="/no-access" replace />;
  }

  return <>{children}</>;
};

export default RoleBasedAuth;
